var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 882,
    height: 683,
    viewBox: "0 0 882 683",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.118 152.996L308.583 94.0279L360.203 117.484L354.81 161.83L308.118 152.996Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.024 294.192L522.489 235.224L574.109 258.68L568.717 303.026L522.024 294.192Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.139 347.712L190.603 288.744L242.223 312.2L236.831 356.546L190.139 347.712Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.045 488.908L404.509 429.94L456.13 453.396L450.737 497.742L404.045 488.908Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.37 245.963L234.835 186.995L286.455 210.451L281.062 254.797L234.37 245.963Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.843 386.547L446.251 324.343L500.682 349.158L495.061 395.931L445.843 386.547Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.391 440.679L116.856 381.711L168.476 405.168L163.084 449.514L116.391 440.679Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.298 581.875L330.762 522.907L382.383 546.364L376.99 590.709L330.298 581.875Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.898 204.352L436.363 145.384L487.983 168.84L482.591 213.186L435.898 204.352Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.806 345.547L650.27 286.579L701.89 310.035L696.498 354.381L649.806 345.547Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.919 399.068L318.383 340.1L370.004 363.556L364.611 407.902L317.919 399.068Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.506 458.078L360.871 410.789L402.265 429.606L397.947 465.169L360.506 458.078Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.825 540.263L532.29 481.295L583.91 504.752L578.517 549.098L531.825 540.263Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.151 297.319L362.616 238.351L414.236 261.807L408.844 306.153L362.151 297.319Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.057 438.514L576.522 379.546L628.142 403.003L622.75 447.349L576.057 438.514Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.172 492.035L244.636 433.067L296.257 456.523L290.864 500.869L244.172 492.035Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.078 633.231L458.543 574.263L510.163 597.719L504.77 642.065L458.078 633.231Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.09 165.438L359.258 117.139L414.911 106.296L436.246 145.545L393.09 165.438Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.997 306.633L573.165 258.334L628.818 247.492L650.153 286.74L606.997 306.633Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.111 360.154L241.279 311.855L296.932 301.013L318.268 340.261L275.111 360.154Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.017 501.35L455.185 453.05L510.839 442.208L532.174 481.456L489.017 501.35Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.343 258.405L285.511 210.105L341.164 199.263L362.499 238.512L319.343 258.405Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.249 399.601L499.417 351.301L555.07 340.459L576.405 379.707L533.249 399.601Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.363 453.122L167.531 404.822L223.184 393.98L244.52 433.228L201.363 453.122Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.269 594.317L381.437 546.018L437.091 535.175L458.426 574.424L415.269 594.317Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.871 216.794L487.039 168.494L542.692 157.652L564.027 196.9L520.871 216.794Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.777 357.989L700.945 309.689L756.598 298.847L777.934 338.096L734.777 357.989Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.891 411.51L369.059 363.21L424.713 352.368L446.048 391.617L402.891 411.51Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.798 552.706L582.966 504.406L638.619 493.564L659.954 532.812L616.798 552.706Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.124 309.761L413.292 261.461L468.945 250.619L490.28 289.868L447.124 309.761Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.03 450.956L627.198 402.657L682.851 391.814L704.187 431.063L661.03 450.956Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.144 504.477L295.312 456.178L350.966 445.335L372.301 484.584L329.144 504.477Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.051 645.673L509.219 597.373L564.872 586.531L586.207 625.779L543.051 645.673Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.531 116.876L325.699 68.5762L381.352 57.7339L402.688 96.9824L359.531 116.876Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.437 258.071L539.605 209.771L595.259 198.929L616.594 238.178L573.437 258.071Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.551 311.592L207.72 263.292L263.373 252.45L284.708 291.699L241.551 311.592Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.458 452.787L421.626 404.488L477.279 393.645L498.614 432.894L455.458 452.787Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.784 209.843L251.952 161.543L307.605 150.701L328.94 189.95L285.784 209.843Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.69 351.038L465.858 302.739L521.511 291.896L542.847 331.145L499.69 351.038Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.804 404.559L133.972 356.259L189.626 345.417L210.961 384.665L167.804 404.559Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.711 545.755L347.879 497.455L403.532 486.613L424.867 525.861L381.711 545.755Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.312 168.231L453.48 119.932L509.134 109.089L530.469 148.338L487.312 168.231Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.218 309.427L667.387 261.127L723.04 250.285L744.375 289.534L701.218 309.427Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.333 362.947L335.501 314.648L391.154 303.806L412.489 343.054L369.333 362.947Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.239 504.143L549.407 455.843L605.06 445.001L626.396 484.249L583.239 504.143Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.77 316.505L275.938 268.205L331.592 257.363L352.927 296.611L309.77 316.505Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.676 457.7L489.845 409.401L545.498 398.559L566.833 437.807L523.676 457.7Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.564 261.198L379.732 212.899L435.386 202.057L456.721 241.305L413.564 261.198Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.589 266.975L449.589 219.72L502.41 207.833L521.781 246.357L480.589 266.975Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.47 402.394L593.638 354.094L649.292 343.252L670.627 382.5L627.47 402.394Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.585 455.915L261.753 407.615L317.406 396.773L338.741 436.021L295.585 455.915Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.491 597.11L475.659 548.811L531.312 537.968L552.647 577.217L509.491 597.11Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.508 217.321L332.676 169.022L388.329 158.18L409.664 197.428L366.508 217.321Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.414 358.517L546.582 310.217L602.235 299.375L623.57 338.623L580.414 358.517Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.528 412.038L214.696 363.738L270.349 352.896L291.685 392.144L248.528 412.038Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.434 553.233L428.602 504.934L484.256 494.091L505.591 533.34L462.434 553.233Z",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg3);
export default __webpack_public_path__ + "static/media/bg3.cd86046da91d7019485c5a0443946e0a.svg";
export { ForwardRef as ReactComponent };